import { FaMedal, FaClock, FaServer, FaHome } from "react-icons/fa";
import bgImage from '../aboutPage/allAboutImages/zpstock-image-1267.webp'
import groupImage from '../../../assests/devlopment/Group 12.png'
import MISSION from '../../mainSection/aboutPage/allAboutImages/1.jpeg'
import VISION from '../../../assests/2.jpg'
import VALUES from '../../../assests/3.jpg'

const whyPoints = [
  "24/7 support and availability",
  "Flexible and scalable technology solutions",
  "Expert and committed professionals",
  "Unique and tailored staffing services",
  "Client-centric software development",
  "Clear and open communication",
];

const features = [
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
];

const data = [
  {
    title: "MISSION",
    icon: MISSION,
    description:
      "Turning dreams into reality is what drives TekIT. Ten years down the line, we envision ourselves as a global leader in AI/ML development and software development services, built on a foundation of strong customer relationships and a commitment to delivering only the best in innovation and technology.",
  },
  {
    title: "VISION",
    icon: VISION,
    description:
      "TekIT’s vision derives from three major qualities: Reliability, Quality & Integrity. There’s basically no limitation when it comes to our custom software development services; we can transform your imagination into the most extraordinary solutions and are always willing to expand our horizons when we get a chance.",
  },
  {
    title: "VALUES",
    icon: VALUES,
    description:
      "Our values are driven by passion, commitment and integrity. We ensure that no client or customer’s demands go unfulfilled and serve them equally with empowering solutions.",
  },
];

export default function TakeBusiness() {
  return (
    <div>
      <div className="bg-[#09588D] py-20 px-4 hidden lg:block">
        <h2 className="2xl:text-[40px] lg:text-[32px] text-[40px]  font-bold text-center font-recoleta mb-12 text-white" data-aos="fade-up">
          Take your business to the next level with TekIT
        </h2>

        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-center gap-10">
          {/* 1st Section */}
          <div className="bg-white text-[#09588D] p-6 rounded-md shadow-lg w-[400px] lg:h-[400px] 2xl:h-[500px] flex flex-col items-center gap-4" data-aos="fade-up">
            <img src={data[0].icon} alt="Mission" className="h-20 w-20" />
            <h3 className="font-bold font-recoleta text-[24px] 2xl:text-[26px] lg:text-[20px] text-left">{data[0].title}</h3>
            <p className="text-[16px] lg:text-[16px] 2xl:text-[20px] text-left">
              {data[0].description}
            </p>
          </div>

          <div className="bg-white text-[#09588D] p-6 rounded-md shadow-lg w-[400px] lg:h-[400px] 2xl:h-[500px] flex flex-col items-center gap-4 relative top-[60px]" data-aos="fade-up">
            <img src={data[1].icon} alt="Mission" className="h-20 w-20" />
            <h3 className="font-bold font-recoleta text-[24px] 2xl:text-[26px] lg:text-[20px] text-center">{data[1].title}</h3>
            <p className="text-[16px] lg:text-[16px] 2xl:text-[20px] text-center">{data[1].description}</p>
          </div>

          <div className="bg-white text-[#09588D] p-6 rounded-md shadow-lg w-[400px] lg:h-[400px] 2xl:h-[500px] flex flex-col items-center gap-4" data-aos="fade-up">
            <img src={data[2].icon} alt="Mission" className="h-20 w-20" />
            <h3 className="font-bold font-recoleta text-[24px] 2xl:text-[26px] lg:text-[20px] text-center">{data[2].title}</h3>
            <p className="text-[16px] lg:text-[16px] 2xl:text-[20px] text-center">{data[2].description}</p>
          </div>
        </div>
      </div>

      <div className="bg-[#09588D] py-20 mt-[-160px] px-4 lg:hidden block">
        <h2 className="2xl:text-[40px] lg:text-[32px] text-[45px]  font-bold text-center font-recoleta mb-12 text-white" data-aos="fade-up">
          Take your business to the next level with TekIT
        </h2>

        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-center gap-10">
          <div className="bg-white text-[#09588D] p-6 rounded-md shadow-lg  h-[640px] flex flex-col items-center gap-4" data-aos="fade-up">
            <img src={data[0].icon} alt="Mission" className="h-20 w-20" />
            <h3 className="font-bold font-recoleta text-[44px] 2xl:text-[26px] lg:text-[20px] text-left">{data[0].title}</h3>
            <p className="text-[40px] lg:text-[16px] 2xl:text-[20px] text-left">
              {data[0].description}
            </p>
          </div>

          <div className="bg-white text-[#09588D] p-6 rounded-md shadow-lg  h-[640px] flex flex-col items-center gap-4 relative " data-aos="fade-up">
            <img src={data[1].icon} alt="Mission" className="h-20 w-20" />
            <h3 className="font-bold font-recoleta text-[44px] 2xl:text-[26px] lg:text-[20px] text-center">{data[1].title}</h3>
            <p className="text-[40px] lg:text-[16px] 2xl:text-[20px] text-center">{data[1].description}</p>
          </div>

          <div className="bg-white text-[#09588D] p-6 rounded-md shadow-lg  h-[480px] flex flex-col items-center gap-4" data-aos="fade-up">
            <img src={data[2].icon} alt="Mission" className="h-20 w-20" />
            <h3 className="font-bold font-recoleta text-[44px] 2xl:text-[26px] lg:text-[20px] text-center">{data[2].title}</h3>
            <p className="text-[40px] lg:text-[16px] 2xl:text-[20px] text-center">{data[2].description}</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 ">
        <div data-aos="fade-up" className="flex flex-col items-center">
          <img src={groupImage} alt="group image" className="justify-self-center" />
        </div>

        <div className=" gap-2">
          <h2 className="text-6xl 2xl:text-[32px] lg:text-[26px] font-semibold text-[#09588D] flex flex-col items-center justify-self-center lg:justify-self-start mb-4" data-aos="fade-up">
            <span className="font-recoleta">Why choose TekIT ?</span>
          </h2>
          <p className="text-gray-700 2xl:text-[24px] lg:text-[20px] text-[42px] mb-6" data-aos="fade-right">
          TekIT delivers reliable AI/ML development, custom software solutions, and expert staffing services backed by years of experience. With a client-first approach, scalable technology, and a proven global track record, we turn ideas into impactful results.
          </p>
          <ul className="space-y-6">
            {whyPoints.map((point, idx) => {
              const colors = ["bg-yellow-200", "bg-blue-200", "bg-pink-200", "bg-green-200", "bg-purple-200"];
              return (
                <li key={idx} className="flex items-start space-x-4" data-aos="fade-up">
                  <div
                    className={`w-10 h-10 flex-shrink-0 rounded-full flex items-center justify-center text-white font-bold text-lg ${colors[idx % colors.length]}`}
                  >
                    {idx + 1}
                  </div>
                  <p className="text-gray-800 2xl:text-[18px] lg:text-[16px] text-[28px]">{point}</p>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

    </div>
  );
}
